<template>
  <!-- 查看合同页面 -->
  <div class="wrap" style="overflow: hidden">
    <yd-navbar title="更新授权委托书" fontsize="16px" style="font-weight: 800;font-family:PingFang SC;color:#000">
      <router-link to="/supplierInfo" slot="left">
        <yd-navbar-back-icon>个人中心</yd-navbar-back-icon>
      </router-link>
    </yd-navbar>
    <yd-cell-group>
      <el-form
        ref="updateGrant"
        :rules="validRules"
        :model="register"
        label-width="120px"
        size="mini"
        style="padding:1em;"
        label-position="left"
        inline-message="true"
      >
        <el-form-item label="授权委托书" prop="grantCard">
            <span slot="label">
              <span> 授权委托书 </span><br />
              <span class="form-label-slot">(请上传小于4M的jpg格式图片)</span>
            </span>
          <el-upload
            class="avatar-uploader"
            v-model="register.grantCard"
            :show-file-list="false"
            :on-success="handleSuccess"
            :before-upload="beforeGrantCardUpload"
          >
            <img
              v-if="register.grantCard"
              :src="register.grantCard"
              class="avatar"
              fit="scale-down"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="委托截止期限" prop="grantDate">
          <el-date-picker
            type="date"
            placeholder="请选择委托截止期限"
            v-model="register.grantDate"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
      </el-form>
    </yd-cell-group>
    <yd-button type="primary" size="large" shape="circle" bgcolor="#2f6fff" color="#fff" @click.native="submitForm('updateGrant')">确认更新</yd-button>

  </div>
</template>

<script>
import axios from "axios";
var baseUrl = process.env.API_ROOT;
export default {
  data() {
    const fileIsJPG = (rule, value, callback) => {
      if (!value) {
        // if (rule.fullField === "grantCard") {
        //   callback(new Error("请选择授权委托书"));
        //   return;
        // } else
          if (rule.fullField === "signImg") {
          callback(new Error("请选择手写签名"));
          return;
        }
      }
      let file = this.base64ToFile(value);
      if (file.type !== "image/jpeg") {
        callback(new Error("请上传jpg格式图片"));
        return;
      }
      if (file.size / 1024 / 1024 > 4) {
        callback(new Error("请上传小于4M格式图片"));
        return;
      }
      callback();
    };
    return {
      register : {
        grantDate: null,
        grantCard: '',
        userId: window.localStorage.getItem("checkUserId"),
      },
      userId: window.localStorage.getItem("checkUserId"),
      validRules: {
        grantDate: [
          { required: true, message: "请输入委托截止期限", trigger: "blur" },
        ],
        grantCard: [{ required: true, trigger: "blur", validator: fileIsJPG }],
      },

    }
  },
  methods: {
    getSupplierUser(){
      axios({
        method: "get",
        url: baseUrl + "supplierUser?userId="+userId
      }).then(resp => {
        if (resp.data.error_code == "0") {

        }
      })
    },
    base64ToFile(urlData, fileName){
      if (!fileName) {
        fileName = "default";
      }
      let arr = urlData.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bytes = atob(arr[1]); // 解码base64
      let n = bytes.length;
      let ia = new Uint8Array(n);
      while (n--) {
        ia[n] = bytes.charCodeAt(n);
      }
      return new File([ia], fileName, { type: mime });
    },
    fileToBase64Async(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          resolve(e.target.result);
        };
      });
    },
    handleSuccess(res, file) {},
    beforeGrantCardUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt4M = file.size / 1024 / 1024 < 10;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt4M) {
        this.$message.error("上传头像图片大小不能超过 4MB!");
      }
      this.fileToBase64Async(file).then((result) => {
        this.register.grantCard = result;
      });
      return isJPG && isLt2M;
    },
    beforeSignImgUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt4M = file.size / 1024 / 1024 < 4;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt4M) {
        this.$message.error("上传头像图片大小不能超过 4MB!");
      }
      this.fileToBase64Async(file).then((result) => {
        this.register.signImg = result;
      });
      return isJPG && isLt2M;
    },
    submitForm(formName) {
      let that = this;
      debugger
      this.$refs[formName].validate((valid) => {
        debugger
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "正在提交，请稍后....",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.6)",
          });
          axios({
            method: "post",
            url: baseUrl + "/updGrant",
            data: this.register,
          }).then((resp) => {
            debugger
            loading.close();
            if (resp.data.result||resp.data.result === "true") {
              this.$dialog.toast({
                mes: '修改成功',
                icon: 'success',
                timeout: 1500
              });
              this.$router.push({path: "/supplierInfo"});
              window.localStorage.setItem("supplierStatus", "3");
            } else {
              this.$dialog.toast({mes: resp.data.message, timeout: 1500});
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  mounted() {
    if(!this.userId){
      //this.$router.push({ path: "/login"});
    }
  }
}
</script>

<style scoped>
.tabbar-footer {
  position: fixed;
  bottom: 0px;
}
/deep/ .avatar-uploader {
  border: 1px rgba(0, 0, 0, 0.5) dashed;
  height: 100px;
  border-radius: ;
  line-height: 100px;
}
.avatar {
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/update-grant.vue